import { Checkbox, FormControl, FormControlLabel, FormGroup } from "@mui/material";
import ScrollShadowWrapper from "components/shared/ScrollShadowWrapper";
import { Body, BodyHighlight } from "helpers/TypographyComponents";
import type { CSSProperties, ReactNode } from "react";
import { Controller } from "react-hook-form";

interface ICheckListFormComponent {
    control: any;
    label?: string;
    controlName: string;
    /**
     * Pass array of data Ids
     * ex: [ 13, 37 ]
     */
    options: number[];
    /**
     * Right label info
     */
    labelInfo?: string;
    sx?: CSSProperties;
    disabledOptions?: number[];
    /**
     * Checklist width
     */
    width?: string;
    fullWidth?: boolean;
    /**
     * maxHeight to active scroll shadow wrapper
     */
    maxHeight?: string;
    /**
     * Render label for an option
     */
    renderOptionLabel: (id: number) => ReactNode;
}

/**
 * Reusable CheckList Form Component :
 * ▢ Naomi
 * ☑ Millie
 * ☑ Josh
 */
const CheckListFormComponent = ({
    control,
    label,
    controlName,
    options,
    labelInfo,
    sx,
    disabledOptions,
    width,
    fullWidth,
    maxHeight,
    renderOptionLabel,
}: ICheckListFormComponent) => {
    return (
        <div className="form-component" style={sx}>
            <FormControl component="fieldset" variant="standard" sx={fullWidth ? { width: "100%" } : { width }}>
                {label && (
                    <div className="form-component-label">
                        <BodyHighlight>{label}</BodyHighlight>
                        {labelInfo && <Body color="grey">{labelInfo}</Body>}
                    </div>
                )}
                <ScrollShadowWrapper style={{ width: "100%", maxHeight, marginTop: "0.2rem" }}>
                    <FormGroup>
                        <Controller
                            name={controlName}
                            control={control}
                            render={({ field }) => {
                                const { value, onChange } = field;
                                const handleCheckboxChange = (event) => {
                                    const { name, checked } = event.target;
                                    const id = +name;
                                    const newValue = checked
                                        ? [id, ...value]
                                        : value.filter((valueId) => valueId !== id);
                                    onChange(newValue);
                                };
                                return (
                                    <>
                                        {options?.map((id) => (
                                            <FormControlLabel
                                                key={`form-checkbox-${controlName}-${id}`}
                                                className="form-check-list-row"
                                                control={
                                                    <Checkbox
                                                        checked={value.includes(id)}
                                                        sx={{ padding: "7px" }}
                                                        size="small"
                                                    />
                                                }
                                                label={renderOptionLabel(id)}
                                                onChange={handleCheckboxChange}
                                                name={String(id)}
                                                disabled={disabledOptions?.includes(id)}
                                            />
                                        ))}
                                    </>
                                );
                            }}
                        />
                    </FormGroup>
                </ScrollShadowWrapper>
            </FormControl>
        </div>
    );
};

export default CheckListFormComponent;
